import { connectSportsWithToken } from "./connectSportsWithToken";
import { AsyncSocket } from "../Network";
import { connectionStore, ConnectionNames } from "../Stores";
import { WCHandlers } from "./App";
export const WCConnectionsFactory = {
    [ConnectionNames.sports]: (connConfig) => {
        const conn = new AsyncSocket({
            url: {
                baseUrl: connConfig.baseUrl,
                queryParams: {
                    jwt: connConfig.queryParams.jwt,
                    locale: connConfig.queryParams.locale
                }
            },
            handlers: WCHandlers[ConnectionNames.sports]
        });
        connectionStore.set(ConnectionNames.sports, conn);
        if (!connConfig.queryParams.jwt) {
            connectSportsWithToken().catch(console.error);
        }
        return conn;
    },
    [ConnectionNames.betslip]: () => { }
};
//# sourceMappingURL=WCConnectionsFactory.js.map